<router-outlet></router-outlet>
<app-update-notice />
<!-- <lib-chatbot></lib-chatbot> -->
